module.exports = __webpack_public_path__ + "img/44.dff90a13.jpg";